export const PERSONALIZATION_TTL = 24 * 60 * 60_000; // 24 hours

/** The only fields needed to render and interact with a prompt card. */
export interface DisplayCard {
  /** Original card title (used for analytics tracking) */
  title: string;
  /** Prompt sent to copilot on click */
  prompt: string;
  /** LLM-rewritten (or original) title shown in the UI */
  displayTitle: string;
  /** LLM-rewritten (or original) description shown in the UI */
  displayDescription: string;
}

interface CachedDisplayCards {
  timestamp: number;
  candidateKey: string;
  cards: DisplayCard[];
}

export function getCachedCards(workspaceId: number, candidateKey: string): DisplayCard[] | null {
  try {
    const raw = localStorage.getItem(`prompt-cards-${workspaceId}`);
    if (raw == null) return null;
    const parsed = JSON.parse(raw) as CachedDisplayCards;
    if (typeof parsed.timestamp !== 'number' || !Array.isArray(parsed.cards)) return null;
    if (Date.now() - parsed.timestamp >= PERSONALIZATION_TTL) return null;
    // Invalidate if the candidate pool has changed since caching
    if (parsed.candidateKey !== candidateKey) return null;
    return parsed.cards;
  } catch {
    return null;
  }
}

export function setCachedCards(workspaceId: number, candidateKey: string, cards: DisplayCard[]): void {
  try {
    const entry: CachedDisplayCards = { timestamp: Date.now(), candidateKey, cards };
    localStorage.setItem(`prompt-cards-${workspaceId}`, JSON.stringify(entry));
  } catch {
    // Storage full or unavailable — silently ignore
  }
}
